import * as z from "zod";
import type {
  OperationsSettingsPatch,
  ReturnsOperationsSettingsSource,
} from "./operations-settings-source";

export const RESTOCK_POLICIES = ["none", "not_damaged", "all"] as const;
export type RestockPolicy = (typeof RESTOCK_POLICIES)[number];

export const inventorySettingsShape = {
  inventory: z.object({
    restock: z.enum(RESTOCK_POLICIES),
    restockShopifyRefunds: z.boolean(),
    skipEcommerceProviderRestock: z.boolean(),
    disposeShopifyReverseFulfillmentOnRestock: z.boolean(),
    allowRestockBeforeProcess: z.boolean(),
  }),
};

export type InventorySettings = z.infer<
  z.ZodObject<typeof inventorySettingsShape>
>;

export function inventorySettingsFromTeam({
  settings,
}: ReturnsOperationsSettingsSource): InventorySettings {
  const { inventory } = settings;
  return {
    inventory: {
      restock: !inventory.restock
        ? "none"
        : inventory.restockDamaged
          ? "all"
          : "not_damaged",
      restockShopifyRefunds: inventory.restockShopifyRefunds ?? false,
      skipEcommerceProviderRestock:
        inventory.skipEcommerceProviderRestock ?? false,
      disposeShopifyReverseFulfillmentOnRestock:
        inventory.disposeShopifyReverseFulfillmentOnRestock ?? false,
      allowRestockBeforeProcess: inventory.allowRestockBeforeProcess ?? false,
    },
  };
}

export function inventoryTeamPatch(
  next: InventorySettings,
): OperationsSettingsPatch {
  const { inventory } = next;
  return {
    set: {
      "inventory.restock": inventory.restock !== "none",
      "inventory.restockDamaged": inventory.restock === "all",
      "inventory.restockShopifyRefunds": inventory.restockShopifyRefunds,
      "inventory.skipEcommerceProviderRestock":
        inventory.skipEcommerceProviderRestock,
      "inventory.disposeShopifyReverseFulfillmentOnRestock":
        inventory.disposeShopifyReverseFulfillmentOnRestock,
      "inventory.allowRestockBeforeProcess":
        inventory.allowRestockBeforeProcess,
    },
    unset: [],
  };
}
